var _path, _path2, _g, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5275 28.2505L29.5312 15.2469C27.7614 14.5104 25.6653 13.3004 23.6828 11.318C21.7001 9.33521 20.4899 7.23871 19.7534 5.46875L6.74953 18.4725C5.7348 19.4874 5.22734 19.9948 4.791 20.5541C4.27625 21.2141 3.83495 21.9281 3.47486 22.6836C3.16961 23.3242 2.94272 24.0049 2.48888 25.3663L0.0957345 32.5458C-0.127596 33.2157 0.0467679 33.9543 0.546158 34.4538C1.04555 34.9532 1.78422 35.1276 2.45421 34.9043L9.63366 32.511C10.9951 32.0572 11.6759 31.8304 12.3164 31.5252C13.0719 31.1651 13.786 30.7238 14.446 30.209C15.0053 29.7726 15.5129 29.2652 16.5275 28.2505Z",
    fill: "url(#paint0_linear_26553_58922)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.0109 11.5929C35.663 8.94084 35.663 4.64105 33.0109 1.98903C30.3588 -0.66301 26.0589 -0.66301 23.4068 1.98903L21.875 3.52087C21.8961 3.58421 21.9177 3.64842 21.9403 3.71347C22.5017 5.33185 23.5612 7.45338 25.5541 9.44626C27.547 11.4391 29.6686 12.4985 31.2871 13.06C31.3518 13.0825 31.4157 13.1041 31.4788 13.125L33.0109 11.5929Z",
    fill: "url(#paint1_linear_26553_58922)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26553_58922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0985 20H35.154C37.8296 20 40 22.1551 40 24.8117V30.4128C40 30.4896 39.9976 30.564 39.9952 30.6408C39.9976 30.6792 40 30.7152 40 30.756V37.8859C40 39.1026 38.9945 40.0937 37.7715 39.9929C36.7757 39.9113 35.9588 39.1434 35.8404 38.1403C35.5407 36.4532 34.0639 35.2245 32.3406 35.2245C26.9411 35.2269 16.0961 35.2269 16.0961 35.2269C16.0961 35.2269 16.0961 35.2269 16.0961 35.2269C13.4205 35.2269 11.25 33.0718 11.25 30.4152C11.25 30.4152 11.25 30.4152 11.25 30.4152C11.25 30.4152 11.25 26.8395 11.25 24.814C11.2524 22.155 13.4229 20 16.0985 20Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7428 30.0362C20.043 30.0362 21.0969 28.9897 21.0969 27.6988C21.0969 26.4078 20.043 25.3613 18.7428 25.3613C17.4427 25.3613 16.3887 26.4078 16.3887 27.6988C16.3887 28.9897 17.4427 30.0362 18.7428 30.0362Z",
    fill: "url(#paint2_linear_26553_58922)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3241 30.0362C26.6243 30.0362 27.6783 28.9897 27.6783 27.6988C27.6783 26.4078 26.6243 25.3613 25.3241 25.3613C24.024 25.3613 22.97 26.4078 22.97 27.6988C22.97 28.9897 24.024 30.0362 25.3241 30.0362Z",
    fill: "url(#paint3_linear_26553_58922)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8183 30.0362C33.1184 30.0362 34.1724 28.9897 34.1724 27.6988C34.1724 26.4078 33.1184 25.3613 31.8183 25.3613C30.5181 25.3613 29.4641 26.4078 29.4641 27.6988C29.4641 28.9897 30.5181 30.0362 31.8183 30.0362Z",
    fill: "url(#paint4_linear_26553_58922)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26553_58922",
    x: 2.43539,
    y: 11.1854,
    width: 46.3792,
    height: 37.6292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26553_58922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26553_58922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26553_58922",
    x1: -0.615234,
    y1: 1.93115,
    x2: 29.3774,
    y2: 35.4614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26553_58922",
    x1: 8.20312,
    y1: -3.14453,
    x2: 34.8633,
    y2: 26.6602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26553_58922",
    x1: 16.3887,
    y1: 25.7266,
    x2: 20.8474,
    y2: 29.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26553_58922",
    x1: 22.97,
    y1: 25.7266,
    x2: 27.4287,
    y2: 29.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26553_58922",
    x1: 29.4641,
    y1: 25.7266,
    x2: 33.9228,
    y2: 29.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefine);
export default __webpack_public_path__ + "static/media/refine.0768f29be60a72049350db43659c65d1.svg";
export { ForwardRef as ReactComponent };